module.exports = __webpack_public_path__ + "static/media/filter.1e0c8091.png";